import React from 'react';
import { Row, Col, Collapse } from 'antd';
import { I18n } from '@aws-amplify/core';

import { TitleForm } from './TitleForm';
import { useEvaluationCategories } from '../hooks/useEvaluationCategories';
import { RiskBadge } from '@/components/views/Resolution886/components/RiskBadge';
import CategoryButton from '@/components/views/Resolution886/components/CategoryButton';
import * as S from '../styles';

interface EvaluationCategoriesFormProps {
	goToSubStep: (step: number) => void;
}

const { Panel } = Collapse;

export function EvaluationCategoriesForm({ goToSubStep }: Readonly<EvaluationCategoriesFormProps>): JSX.Element {
	const {
		isLoading,
		activeKey,
		categories,
		assessment,
		newReview,
		previousReview,
		previousCategories,
		handleCategoryClick,
		handleOnToggleCollapse
	} = useEvaluationCategories({
		goToSubStep
	});

	return (
		<Row gutter={[16, 16]}>
			<Col span={24}>
				<S.DefaultStepHeading>{assessment.activity?.name}</S.DefaultStepHeading>
			</Col>
			<Col span={24}>
				<TitleForm
					title="Evaluation of risk factors"
					subtitle="Select the risk factor to carry out the evaluation. Factors not evaluated will be considered a tolerable risk."
				/>
			</Col>
			{(newReview || previousReview?.id) && (
				<Col span={24}>
					<S.CustomButtonDefault
						type="default"
						onClick={handleOnToggleCollapse}
						className={activeKey.length ? 'active' : ''}
					>
						{I18n.get('View previous evaluation')}
					</S.CustomButtonDefault>
					<S.CustomCollapse activeKey={activeKey} bordered={false}>
						<Panel key="1" showArrow={false} header={null}>
							<Row gutter={[48, 16]}>
								{previousCategories &&
									previousCategories?.length &&
									previousCategories?.map((category, index) => (
										<Col span={12} key={index}>
											<p>{I18n.get(category.name)}</p>
											<RiskBadge risk={category.risk} />
										</Col>
									))}
							</Row>
						</Panel>
					</S.CustomCollapse>
				</Col>
			)}
			{categories.map((category, index) => (
				<CategoryButton
					key={index}
					loading={isLoading}
					name={category.name}
					category={category}
					onClick={handleCategoryClick}
				/>
			))}
		</Row>
	);
}
